import { useUser } from './useUser';
import { IPermissions } from 'domain/store/UserModel';

export function usePermissions(): IPermissions {
  const { permissions } = useUser();

  return permissions;
}
